import { z } from "zod/v4";

export const E_UsageFeature = {
  PRISM_QUERIES: "prism_queries",
} as const;

export type T_UsageFeature =
  (typeof E_UsageFeature)[keyof typeof E_UsageFeature];

export const USAGE_FEATURE_DISPLAY_NAMES = {
  [E_UsageFeature.PRISM_QUERIES]: "Prism messages",
} as const satisfies Record<T_UsageFeature, string>;

export const USAGE_FEATURE_UNIT_NAMES = {
  [E_UsageFeature.PRISM_QUERIES]: "message",
} as const satisfies Record<T_UsageFeature, string>;

export const E_UsagePeriod = {
  DAILY: "DAILY",
  MONTHLY: "MONTHLY",
} as const;

export type T_UsagePeriod = (typeof E_UsagePeriod)[keyof typeof E_UsagePeriod];

export type T_UsageFeatureStats = {
  bonus_credits: number;
  cycle_start: Date;
  display_name: string;
  effective_limit: number | null;
  feature: T_UsageFeature;
  next_cycle: Date;
  period: T_UsagePeriod;
  used: number;
};

export const E_UsageLimitCauseType = {
  MESSAGE_LIMIT_EXCEEDED: "MESSAGE_LIMIT_EXCEEDED",
} as const;

export const z_UsageLimitExceededCause = z.object({
  current: z.number().int().nonnegative(),
  feature: z.enum(E_UsageFeature),
  limit: z.number().int().nonnegative(),
  period: z.enum(E_UsagePeriod),
  resetAt: z.iso.datetime(),
  type: z.literal(E_UsageLimitCauseType.MESSAGE_LIMIT_EXCEEDED),
});

export type T_UsageLimitExceededCause = z.infer<
  typeof z_UsageLimitExceededCause
>;
